module Meevo.Plugins.Drawer {
	"use strict";

	/**
	* Main Section of drawer 
	*/
	export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Drawer> {
		/**
		* Base class override which defines what a DEFAULT model looks like.
		*/
		createSectionModelInstance(postAdd: (data: any) => any): void {
			this.dataService.getTemplate(this.baseEndpoint).then((data) => {
				this.model = data;
			});
		}

		privateUserChanged() {
			this.model.privateUserId = this.model.privateUser ? this.model.privateUser.id : undefined;
		}

		printerChanged() {
			this.model.printerId = this.model.printer ? this.model.printer.id : undefined;
		}

		postCopy(): void {
			if (this.model) {
				this.model.tenantEntityVersion = 0;
            }
		}
	}
}